import {
  Box,
  Button,
  Checkbox,
  Collapse,
  FormControl,
  Grid,
  InputLabel,
  ListItemText,
  MenuItem,
  OutlinedInput,
  Paper,
  Select,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import MainCard from "../../components/ui-component/card/MainCard";
import { SettingsBackupRestore } from "@mui/icons-material";

import FilterAltIcon from "@mui/icons-material/FilterAlt";
import { useActionData } from "react-router-dom";
import CustomTextFieldComp from "../../newComponent/customTextFieldComp";
import CustomAutocompleteComp from "../../newComponent/AutocompleteComp";
import ApplyFilterButton from "../../newComponent/NewButtonComp/ApplyFilterButton";
import ResetFilterButton from "../../newComponent/NewButtonComp/ResetFilterButton";
import { useGetTokenOrLogout } from "../../../utils/token";
import CustomSnackbar from "../../components/ui-component/snackbar/CustomSnackbar";
import { useDateUtils } from "../../../utils/formatTime";
const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;

const CollapsibleForm = ({
  onApplyFilter,
  onResetFilter,
  open,
  handleToggle,
  setIsLoading,
  setOriginalPayments,
  originalPayments,
  setPayments,
}) => {
  const today = new Date().toISOString().split("T")[0];
  const { todaysDate, oneMonthAgoDate } = useDateUtils();
  const userId = localStorage.getItem("userId");
  const getTokenOrLogout = useGetTokenOrLogout();
  const [name, setName] = useState("");
  const [mobile, setMobile] = useState("");
  const [countryList, setCountryList] = useState([]);
  const [countryIds, setCountryIds] = useState([]);
  const [branchlist, setBranchlist] = useState([]);
  const [branch, setBranch] = useState([]);
  const [paymentMode, setPaymentMode] = useState([]);
  const [paymentname, setpaymentname] = useState([]);
  const [amountFrom, setAmmounfrom] = useState("");
  const [amountTo, setAmountTo] = useState("");
  const [startDate, setStartDate] = useState(oneMonthAgoDate);
  const [endDate, setEndDate] = useState(todaysDate);
  const [loading, setLoading] = useState(true);
  const [snackbarOpen, setSnackbarOpen] = React.useState(false);
  const [snackbarMessage, setSnackbarMessage] = React.useState("");
  const [snackbarSeverity, setSnackbarSeverity] = React.useState("success");
    const [createdbylist, setCreatedbylist] = useState([]);
    const [createdby, setCreatedby] = useState([]);
  const showSnackbar = (message, severity) => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setSnackbarOpen(true);
  };
  const [status, setSatus] = useState([
   
    ]);
    const [selectedStatus, setSelectedStatus] = useState([1, 0]);

   const [statusList, setStatusList] = useState([
      { id: 1, name: "Active" },
      { id: 0, name: "Inactive" },
    ]);

  // const handleToggle = () => {
  //   setOpen(!open);
  // };
  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
  };

  const newBranch = branch.map((i) => i.id);
  const newPaymentName = paymentname.map((i) => i.id);

  const handleApplyFilter = async (event) => {
    setIsLoading(true);

    const token = getTokenOrLogout();
    if (!token) return;
    let headers = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    };

    const requestData = {
      user_id: parseInt(userId),
      branch_id: newBranch,
      payment_mode: newPaymentName,
      payment_from_date: startDate,
      payment_to_date: endDate,
      country_id: countryIds,
      collected_by:createdby.map((i)=>i.user_id)
    };

    try {
      const response = await fetch(
        `${API_ENDPOINT}accountantdashboard/paid-amount-filter`,
        {
          method: "POST",
          headers,
          body: JSON.stringify(requestData),
        }
      );

      const result = await response.json();
      if (response.ok) {
        setIsLoading(false);
        setPayments(result);
      } else if (response.status === 401) {
        showSnackbar(result.message, "error");
        setIsLoading(false);
      } else if (response.status === 403) {
        showSnackbar(result.message, "error");
        setIsLoading(false);
      } else if (response.status === 400) {
        showSnackbar(result.message, "error");
        setIsLoading(false);
      } else {
        showSnackbar("Error fetching data:", "error");
        setIsLoading(false);
      }
    } catch (error) {
      console.log("Error fetching data:", error);
      showSnackbar("Error fetching data:", error);
      setIsLoading(false);
    }
  };

  const resetfilter = () => {
    setName("");
    setMobile("");
    setBranch([]);
    setpaymentname([]);
    setStartDate(oneMonthAgoDate);
    setEndDate(todaysDate);
    setAmountTo("");
    setAmmounfrom("");
    setPayments(originalPayments);
    setCountryIds([]);
    setCreatedby([])
  };
  const handelnamechange = (e) => {
    setName(e.target.value);
  };
  const handelmobilechange = (e) => {
    setMobile(e.target.value);
  };


  const allStatusList = [{ id: 2, name: "Both" }, ...statusList];
  const handleStatusChange = (e, value) => {
    if (value.some((item) => item.id === 2)) {
      const selectedIds = statusList.map((i) => i.id);
      setSatus(statusList);
      setSelectedStatus(selectedIds);
    } else {
      const selectedIds = value.map((i) => i.id);
      setSatus(value);
      setSelectedStatus(selectedIds);
    }
  };

  useEffect(() => {
    fetch(`${API_ENDPOINT}country`)
      .then((response) => response.json())
      .then((data) => {
        const filteredCountry = data.filter(
          (i) => i.country_name === "India" || i.country_name === "Nepal"
        );
        setCountryList(filteredCountry);
      })
      .catch((error) => {
        console.error("Error fetching state:", error);
      });
  }, []);

  const handleChangeCountry = (e) => {
    setCountryIds(e.target.value);
    setBranch([])
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${API_ENDPOINT}branch`);
        if (response.ok) {
          const data = await response.json();
const filteredBranch =data.filter((i)=>countryIds.includes(i.country_id))

if(countryIds.length >0  ) {
  setBranchlist(filteredBranch);
}
else{
  setBranchlist(data)
}
        

      
        } else {
          throw new Error(`Request failed with status: ${response.status}`);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
        setLoading(false);
      }
    };

    fetchData();
  }, [countryIds]);

  const allbranchList = [{ branch_name: "Select All" }, ...branchlist];

  const handelbranchchange = (event, value) => {
    if (value.some((option) => option.branch_name === "Select All")) {
      setBranch(branchlist);
    } else {
      setBranch(value);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${API_ENDPOINT}paymentmode`);
        if (response.ok) {
          const data = await response.json();
          const activePayments = data.filter((item) => item.is_active === 1 || true);
          setPaymentMode(activePayments);

          setLoading(false);
        } else {
          throw new Error(`Request failed with status: ${response.status}`);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const handleChangepayment = (event, value) => {
    setpaymentname(value);
  };

  const ammountfrom = (e) => {
    setAmmounfrom(e.target.value);
  };

  const ammountto = (e) => {
    setAmountTo(e.target.value);
  };

  const handelstartdate = (e) => {
    setStartDate(e.target.value);
  };

  const handeltodate = (e) => {
    setEndDate(e.target.value);
  };

  useEffect(() => {
      const fetchData = async () => {

         const requestData = {
         status: selectedStatus,
         branch_id: newBranch,
         country_id:countryIds
    };
        try {
         // const response = await fetch(`${API_ENDPOINT}route/getallactiveandinactiveuser` );
           const response = await fetch(`${API_ENDPOINT}advisor/bystutus`, {
           method: "POST",
            headers: {
          "Content-Type": "application/json",
           },
            body: JSON.stringify(requestData),
      });

          if (response.ok) {
            const data = await response.json();
            setCreatedbylist(data);
          } else {
            throw new Error(`Request failed with status: ${response.status}`);
          }
        } catch (error) {
          console.error("Error fetching data:", error);
        }
      };
  
      fetchData();
    }, [branch, countryIds,selectedStatus]);

      const allcreatedByList = createdbylist.length >0? [{ first_name: "Select All"  }  , ...createdbylist]:[];
   
  const handelcretedby = (event, value) => {
    if (value.some((option) => option.first_name === "Select All")) {
      setCreatedby(createdbylist);
    } else {
      setCreatedby(value);
    }
  };
  

  return (
    <>
      {/* {open ? 'Hide filter' : 'Show Filter'} */}
      {/* <FilterAltIcon sx={{width:'100px'}} onClick={handleToggle}/>      */}

      <Collapse in={open}>
        <MainCard>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={4} md={3}>
              <Typography variant="h6"> Country</Typography>
              <Select
                multiple
                size="normal"
                select
                value={countryIds}
                onChange={handleChangeCountry}
                fullWidth
                style={{ borderRadius: "10px" }}
              >
                {countryList?.map((country) => (
                  <MenuItem key={country.id} value={country.id}>
                    {country.country_name}
                  </MenuItem>
                ))}
              </Select>
            </Grid>

            <Grid item xs={6} lg={3} md={6} sm={6}>
              <Typography variant="h6">Branch</Typography>

              <CustomAutocompleteComp
                size="small"
                fullWidth
                value={branch}
                multiple
                onChange={handelbranchchange}
                options={allbranchList}
                getOptionLabel={(option) => option.branch_name}
                tooltipContent={(option) => option.branch_name}
              />
            </Grid>
            <Grid item xs={6} lg={3} md={6} sm={6}>
              <Typography variant="h6">Status</Typography>

              <CustomAutocompleteComp
                   multiple
                      value={status}
                      onChange={handleStatusChange}
                      size="small"
                      options={allStatusList}
                      getOptionLabel={(option) => option.name}
                      tooltipContent={(option) => option.name}
              />
            </Grid>

             <Grid item xs={12} lg={3} sm={6} md={6}>
                          <Typography variant="h6">Collected By </Typography>
            
                          <CustomAutocompleteComp
                       
                            fullWidth
                            value={createdby}
                            multiple
                            onChange={handelcretedby}
                            options={allcreatedByList}
                            getOptionLabel={(option) =>
                              `${option.first_name ? option.first_name : ""} ${
                                option.last_name ? option.last_name : ""
                              }`
                            }
                           tooltipContent={(option) =>
                            `${option.first_name ? option.first_name : ""} ${
                              option.last_name ? option.last_name : ""
                            }`

                          }

                           noOptionsText={
                            allcreatedByList.length === 0
                            ? "No Advisor Available"
                            : ""
                      }
                          />
                        </Grid>

            <Grid item xs={6} lg={3} md={6} sm={6}>
              <Typography variant="h6">Payment Mode</Typography>

              <CustomAutocompleteComp
                size="small"
                fullWidth
                value={paymentname}
                multiple
                onChange={handleChangepayment}
                options={paymentMode}
                getOptionLabel={(option) => option.payment_mode}
                tooltipContent={(option) => option.payment_mode}
              />
            </Grid>
            {/* </Box> */}
            {/* <Box sx={{ display: 'flex', flexDirection: 'row', mt: 2 }}> */}
            <Grid item xs={6} lg={3} md={6} sm={6}>
              <Typography variant="h6">Payment Date From</Typography>
              <CustomTextFieldComp
                size="normal"
                sx={{ mb: 1, width: "100%" }}
                type="date"
                value={startDate}
                onChange={handelstartdate}
                InputLabelProps={{
                  shrink: true,
                }}
                InputProps={{
                  style: { borderRadius: "10px" },
                  inputProps: { max: today },
                }}
              />
            </Grid>
            <Grid item xs={6} lg={3} md={6} sm={6}>
              <Typography variant="h6">Payment Date To</Typography>
              <CustomTextFieldComp
                size="normal"
                sx={{ mb: 1, width: "100%" }}
                type="date"
                value={endDate}
                onChange={handeltodate}
                InputLabelProps={{
                  shrink: true,
                }}
                InputProps={{
                  style: { borderRadius: "10px" },
                  inputProps: { max: today },
                }}
              />
            </Grid>

                

            {/* </Box> */}

            <Grid
              item
              xs={12}
              sm={12}
              lg={12}
              md={12}
              container
              justifyContent="end"
              gap={1}
            >
              <ApplyFilterButton onClick={handleApplyFilter} />

              <ResetFilterButton onClick={resetfilter} />
            </Grid>
            {/* </Box> */}
          </Grid>
        </MainCard>
      </Collapse>

      <CustomSnackbar
        open={snackbarOpen}
        onClose={() => setSnackbarOpen(false)}
        message={snackbarMessage}
        severity={snackbarSeverity}
      />
    </>
  );
};

export default CollapsibleForm;
